<template lang="pug">
  v-container.layout(fluid)
    v-layout(column wrap align-center justify-center)
      v-progress-circular(
        :size='80'
        :width='8'
        color='primary'
        indeterminate
      )
      span Connecting your Microsoft account...
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  data() {
    return {
      code: '',
    };
  },
  async mounted() {
    const scopes = localStorage.getItem('exchangeScopes');
    localStorage.removeItem('exchangeScopes');

    const featureIds = JSON.parse(localStorage.getItem('exchangeFeatureIds'));
    localStorage.removeItem('exchangeFeatureIds');

    const payload = {
      code: this.$route.query.code,
      feature_ids: featureIds,
      exchange_scopes: scopes,
    };
    await this.connectExchangeToNylas(payload);
    await this.callUpdateFeatureFlag({ flag: 'nylas-ms-reauth', active: false });
    window.close();
  },
  computed: {
    ...mapState({
      exchanceConnectionScopes: state => state.emailManagement.exchanceConnectionScopes,
    }),
    ...mapGetters({
      userHasFeatureFlag: 'userInformation/userHasFeatureFlag',
    }),
  },
  methods: {
    ...mapActions('emailManagement', ['connectExchangeToNylas']),
    ...mapActions('ldAppLayout', ['callUpdateFeatureFlag']),
  },
};
</script>
